<template>
  <div class="relative">
    <input
      type="text"
      id="search"
      v-model="search"
      placeholder="Search quotes"
      class="py-1 px-2 md:py-2 md:px-3 text-xl font-semibold w-full text-gray-800 rounded focus:border-2 border-gray-500"
      autocomplete="off"
    />

    <!-- Search Icon -->
    <div class="absolute top-0 right-0">
      <svg class="w-6 md:w-8 text-black mt-2 mr-2" viewBox="0 0 24 24">
        <path
          style="fill: #ec8834"
          d="m16.32 14.9 5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12"
        />
      </svg>
    </div>

    <!-- search results -->
    <div
      class="z-50 absolute bg-white text-gray-800 text-xl box-shadow rounded w-full mt-1"
      style="display: block;"
      id="suggestions"
    >
      <ul>
        <li v-for="item in items" :key="item" class="border-b border-orange-400">
          <a
            :aria-label="item.advice"
            :href="'/' + item.id"
            class="block hover:bg-gray-400 px-3 py-3 flex items-center"
          >
            <span class="ml-4 font-semibold text-sm sm:text-md md:text-lg">{{ item.advice }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.makeSearch();
    this.globalEventListeners();
    this.searchEventListeners();
  },
  data() {
    return {
      search: "",
      items: [],
    };
  },
  methods: {
    makeSearch() {
      var s_input = document.querySelector("#search");

      s_input.addEventListener("keyup", () => {
        fetch(`https://api.adviceslip.com/advice/search/` + this.search)
          .then((response) => response.json())
          .then((data) => {
            if (data?.slips?.length > 0) {
              const items = data?.slips?.slice(0, 5)?.map((x) => ({
                id: x?.id,
                advice: x?.advice,
              }));
              this.items = items;
            } else {
              this.items = [];
            }
          })
          .catch(() => null);
      });
    },
    wait() {
      var start = new Date().getTime();
      for (var i = 0; i < 1e7; i++) {
        if (new Date().getTime() - start > 150) {
          break;
        }
      }
    },
    clickAway() {
      document.querySelector("#suggestions").style.display = "none";
    },
    click() {
      document.querySelector("#suggestions").style.display = "block";
    },
    searchEventListeners() {
      var s_input = document.querySelector("#search");

      s_input.addEventListener("keydown", () => {
        this.click();
      });
      s_input.addEventListener("click", () => {
        this.click();
      });
    },
    globalEventListeners() {
      // escape key listener
      window.addEventListener("keydown", (e) => {
        if (e.keyCode === 27) {
          this.clickAway();
        }
      });
      // mouse click listener
      window.addEventListener("click", () => {
        this.clickAway();
      });
    },
  },
};
</script>
